<script setup lang="ts">
    import { useTheme } from 'vuetify';
    import { useUserStore } from '@/stores/user';
    import { formatOdds } from '@/helpers';

    const { orderId, odds, stake } = defineProps<{
        orderId: number;
        odds: string;
        stake: string;
    }>();

    const theme = useTheme();
    const userStore = useUserStore();
    const { t } = useI18n();

    const orderInfoLine = computed(() => {
        const currency = userStore.currency.symbol;
        const oddsStr = odds ? formatOdds(odds, 3) : '';
        return `${t('order.order')} #${orderId} — ${currency}${stake} @${oddsStr}`;
    });
</script>

<template>
    <v-chip :color="theme.name.value === 'dark' ? '#323338' : '#e3e3e3'" class="info-line info-chip" label variant="flat">
        <span v-html="orderInfoLine"></span>
    </v-chip>
</template>

<style scoped>
    .info-line {
        font-weight: 500;
    }

    .info-chip {
        padding: 0 5px;
        font-size: 16.25px;
        height: 32px;
        margin-top: 6px;
    }

    .v-theme--light .info-line.v-chip {
        background-color: #f7f7f7 !important;
        border-color: #e3e3e3 !important;
        border-width: 1px !important;
        border-style: solid !important;
    }

    .v-theme--light .info-line.v-chip:before {
        background-color: #f7f7f7;
    }

    .v-theme--dark .info-line.v-chip {
        background-color: #323338 !important;
    }

    .v-theme--dark .info-line.v-chip:before {
        background-color: #323338;
    }
</style>
